module.exports = __webpack_public_path__ + "static/media/kia-parking-selected.9ab05d94.svg";